export const initialState = {
	data: [],
	boolMap: {},
	domainMap: {},
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined
};

export default initialState;
